import React from 'react';
import PropTypes from 'prop-types';
import Translations from '../../../translation/translation';

function MissingTyreIndexAndPassword({ onClick }) {
    return (
        <Translations
            translationKey="catalog-statusbar-mobile-missing-status-tyre-index-postcode-missing"
            className="statusbar-mobile__missing-status statusbar-mobile__missing-status--tyre-index-postcode-missing"
            tagName="div"
            onClick={onClick}
        />
    );
}

MissingTyreIndexAndPassword.propTypes = {
    onClick: PropTypes.func.isRequired,
};

export { MissingTyreIndexAndPassword };
